import subTenantFilters from '@/app/dashboard/sub-tenants/filters';
import { StatusBadge } from '@/components/ui/statusBadge';
import { cn } from '@/lib/cn';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import { SubTenantConfig, type SubTenant } from '@pigello/pigello-matrix';
import Dot from './dot';
import type { RelationFieldProps } from './types';

export const SubTenantItem: RelationFieldProps<SubTenant> = {
  filters: subTenantFilters,
  nested: getRelationFieldNames(SubTenantConfig),
  renderItem: (item, isRelationField) => ({
    title: item?.communicationName,
    badge:
      item.status != null ? (
        <StatusBadge
          className='font-medium'
          type='tenant'
          status={item.status}
        />
      ) : undefined,
    descriptionItems: (
      <div
        className={cn(
          'flex w-full items-center',
          isRelationField && 'justify-between'
        )}
      >
        <span>
          {item.isCompany
            ? (item.orgNo ?? 'Inget Org.nr angivet')
            : (item.ssn ?? 'Inget personnummer angivet')}
        </span>
        {!isRelationField && <Dot />}
        <span>{item?.customId ?? 'Inget objekts-id angivet'}</span>
      </div>
    ),
  }),
};
